export default "b7b85d0dcee39e7d.svg"